<template>
  <div :class="[{ edited_scrollbar: isMac }]">
    <div v-if="getRestrictStatus" class="mt-n16">
      <Error403 />
    </div>
    <div style="height: calc(100vh - 60px)" class="y-scroll mx-2">
      <div>
        <div v-if="getDashboardView == 'company'">
          <Trends />
          <TopProjectsCard
            v-if="
              getSelectedCompany.role == 'admin' ||
                getSelectedCompany.role == 'owner'
            "
          />
          <TopEmployeesCard v-if="getSelectedCompany.role != 'employee'" />
        </div>
        <div v-if="getDashboardView == 'team leads'">
          <Trends />
          <TopEmployeesCard v-if="getSelectedCompany.role != 'employee'" />
        </div>
        <div v-if="getDashboardView == 'employees'">
          <Trends />
          <TopTasks
            v-if="getDashboardView == 'employees' && getDashboardMember"
          />
        </div>
        <div v-if="getDashboardView == 'departments'">
          <Trends />
          <TopDepartments
            v-if="
              getSelectedCompany.role == 'admin' ||
                getSelectedCompany.role == 'owner'
            "
          />
          <TopEmployeesCard v-if="getSelectedCompany.role != 'employee'" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import dateFilter from "@/dateFilter.js";

export default {
  data() {
    return {
      search: null,
      dropdownList: [
        { text: "Today" },
        { text: "Yesterday" },
        { text: "Last 7 days" },
        { text: "Last 30 days" },
        { text: "This month" },
      ],
    };
  },
  components: {
    Trends: () => import("@/components/Dashboard/Trends"),
    TopProjectsCard: () => import("@/components/Dashboard/TopProjects"),
    // Activity: () => import("@/components/Dashboard/Activity"),
    TopEmployeesCard: () => import("@/components/Dashboard/TopEmployees"),
    TopTasks: () => import("@/components/Dashboard/TopTasks"),
    // profileImage: () => import("@/components/Includes/ProfileImage"),
    TopDepartments: () => import("@/components/Dashboard/TopDepartments"),
    Error403: () => import("@/components/Includes/403.vue"),
  },
  methods: {
    selectMember(member) {
      if (member) {
        this.$store.commit("setDashboardMember", member);
        if (this.getDashboardView == "team leads") {
          this.$store.commit("setDashboardFilter", {
            leader_id: member.id,
          });
        }
        if (this.getDashboardView == "employees") {
          this.$store.commit("setDashboardFilter", {
            employee_id: member.id,
          });
        }
      }
    },
  },
  computed: {
    ...mapGetters([
      "getSelectedCompany",
      "getDashboardDateFilter",
      "getTeamLeads",
      "getAllMembers",
      "getLoggedInUser",
      "getDashboardFilters",
      "getDashboardView",
      "getDashboardMember",
      "getRestrictStatus",
    ]),

    // List of employees/team leads
    list() {
      return this.getDashboardView == "team leads"
        ? this.search
          ? this.getTeamLeads.filter((item) => {
              return item.name
                ? item.name.toLowerCase().includes(this.search.toLowerCase())
                : item.email.toLowerCase().includes(this.search.toLowerCase());
            })
          : this.getTeamLeads
        : this.getDashboardView == "employees"
        ? this.search
          ? this.getAllMembers.filter((item) => {
              return item.name
                ? item.name.toLowerCase().includes(this.search.toLowerCase())
                : item.email.toLowerCase().includes(this.search.toLowerCase());
            })
          : this.getAllMembers
        : [];
    },
  },
  watch: {
    getDashboardView(value) {
      if (value) {
        if (value == "employees") {
          this.$store.commit("setDashboardFilter", {
            toggle: "employee",
            employee_id:
              this.getSelectedCompany.role == "employee"
                ? this.getLoggedInUser.id
                : this.getAllMembers[0]
                ? this.getAllMembers[0].id
                : null,
            leader_id: null,
          });
          this.$store.commit(
            "setDashboardMember",
            this.getSelectedCompany.role == "employee"
              ? this.getLoggedInUser
              : this.getAllMembers
              ? this.getAllMembers[0]
              : {}
          );
        }

        if (value == "team leads") {
          this.$store.commit("setDashboardFilter", {
            toggle: "names",
            leader_id:
              this.getSelectedCompany.role == "team-manager"
                ? this.getLoggedInUser.id
                : this.getTeamLeads[0]
                ? this.getTeamLeads[0].id
                : null,
            employee_id: null,
          });
          this.$store.commit(
            "setDashboardMember",
            this.getSelectedCompany.role == "team-manager"
              ? this.getLoggedInUser
              : this.getTeamLeads
              ? this.getTeamLeads[0]
              : {}
          );
        }

        if (value == "company") {
          this.$store.commit("setDashboardFilter", {
            employee_id: null,
            leader_id: null,
            toggle: "company",
          });
        }
      }
    },
  },
  mounted() {
    dateFilter.update(this.getDashboardDateFilter, "setDashboardFilter");
    this.$store.commit(
      "setDashboardView",
      this.getSelectedCompany.role == "employee"
        ? "employees"
        : this.getSelectedCompany.role == "team-manager"
        ? "team leads"
        : "company"
    );
  },
};
</script>
<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: #dcd8f3;
}
</style>
